<template>
    <div>
        <highcharts
            v-if="loaded"
            :options="getOptions(chartOptions)"
            ref="chart"
        />

        <div v-else class="d-flex justify-content-center">
            <b-spinner :style="{'color':constants.spinnerColor}"></b-spinner>
        </div>

        <label><input type="checkbox" v-model="showAll"/> Show All Countries</label>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from "highcharts/modules/exporting"
    import dashboardChartMixin from '@/mixins/dashboardChartMixin'

    typeof exportingInit === 'function' && exportingInit(Highcharts);

    export default {
        name: 'StartupsByCountriesAndAllyTypesChart',
        mixins: [dashboardChartMixin],
        components: {
            highcharts: Chart
        },
        data() {
            return {
                loaded: false,
                showAll: false,
                chartName: "StartupsByCountriesAndAllyTypes",
                chartOptions: {
                    chart: {
                        type: 'column',
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: 'Companies by Country and Ally Type',
                        align: 'left'
                    },
                    plotOptions: {
                        column: {
                            stacking: "normal",
                        },
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                style: {
                                    textShadow: false,
                                    fontSize: "10px"
                                }
                            },
                        }
                    },
                    xAxis: {
                        categories: []
                    },
                    yAxis: {
                        title: {
                            text: ''
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: ( // theme
                                    Highcharts.defaultOptions.title.style &&
                                    Highcharts.defaultOptions.title.style.color
                                ) || 'gray',
                                textOutline: 'none'
                            }
                        }
                    },
                    legend: {
                        align: 'center',
                        x: 0,
                        verticalAlign: 'top',
                        y: 25,
                        floating: false,
                        backgroundColor: 'transparent',
                        borderWidth: 0,
                        shadow: false,
                        layout: 'horizontal'
                    },
                    tooltip: {
                        headerFormat: '<b>{category}</b><br/>',
                        pointFormat: '{series.name}: {point.y}<br/>',
                        shared: true,
                        footerFormat: '<b>Total: {point.stackTotal}</b>'
                    },
                    series: [],
                    colors: ['#043648', '#00afef', '#a50000', '#ffbf1c', '#0083b2', '#44bf2e', '#a11cff', '#ff5e1c']
                },
            }
        },
        watch: {
            showAll() {
                this.filters.showAll = this.showAll;
                this.fetchChartData()
            },
        },
        methods: {
            fetchChartData(initialCall = false) {
                this.filters.showAll = this.showAll;
                this.getChartData(this.chartName).then(response => {
                    let data = response.data

                    this.chartOptions.series = data.ally_types.map(item => ({
                        name: item.name,
                        data: item.data,
                        events: {
                            click: (e) => {
                                this.openStartupsModal(e.point.category, item.name)
                            }
                        }
                    }))

                    this.chartOptions.xAxis.categories = data.countries

                    if (!initialCall) {
                        this.$refs.chart.chart.hideLoading()
                    } else {
                        this.loaded = true
                    }
                })
            },

            openStartupsModal(country, allyType) {
                this.$emit('showStartups', [this.chartName, `Startups from "${country}" of type "${allyType}"`, JSON.stringify([country, allyType])])
            }
        }
    }
</script>
